import { createContext } from 'react';

import type { Organization, OrgRole } from '~/types';

export interface TenantContextType {
  /** Current organization (selected org or first org, or null if none/loading) */
  currentOrg: Organization | null;
  /** User's role in current org (null if no org or role not available) */
  currentOrgRole: OrgRole | null;
  /** True when tenant is resolved and persisted - safe to make tenant-scoped API calls */
  isTenantReady: boolean;
  /** True while fetching organization data */
  loading: boolean;
  /** Invalidate and refetch organization data */
  refreshOrganization: () => Promise<void>;
  /** All organizations user is a member of */
  organizations: Organization[];
  /** Set active organization (triggers cache invalidation) */
  setActiveOrg: (orgId: string) => void;
}

export const TenantContext = createContext<TenantContextType | undefined>(undefined);
